module.exports = __webpack_public_path__ + "static/media/screenshot(23).c8cbae83.jpg";